$(function() {
    $('.header--middle-center .list-menu--inline a[href*=\\#]:not([href=\\#]), .footer-block__details-content a[href*=\\#]:not([href=\\#])').on('click', function() {
        var target = $(this.hash);
        target = target.length ? target : $('[name=' + this.hash.substr(1) +']');
        if (target.length) {
            $('html,body').animate({
                scrollTop: target.offset().top - 90
            }, 1000);
            return false;
        }
    });
});


$('.medleys-wrapper .side-off, div#make-popup a').on('click', function() {
  $('.newsletter-popup').addClass('active');
});

 document.querySelectorAll(".header__inline-menu details").forEach((item) => {
    let timeout;

    item.addEventListener("mouseenter", () => {
      clearTimeout(timeout);
      item.setAttribute("open", true);
    });

    item.addEventListener("mouseleave", () => {
      timeout = setTimeout(() => {
        item.removeAttribute("open");
      }, 200); // little delay here to keep the menu alive during the choice :)
    });
  });

document.getElementById('HeaderMenu-all-products').addEventListener('click', function (event) {
    event.preventDefault();
    event.stopPropagation();
    window.location.href = '/collections/all';
});
